// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3puiF","requiredAsterisk":"Info_requiredAsterisk__1lskO"};